module.exports = __webpack_public_path__ + "img/logo.4f172b78.png";